function SubscriptionCardSkeleton() {
  return (
    <div role='status' aria-hidden={true} className='flex flex-col bg-white border border-gray-200 rounded-md'>
      <header className='flex items-center justify-between p-4 pt-5 bg-gray-100 rounded-t-md h-[74px]'>
        <div className='flex items-center gap-3'>
          <div className='bg-gray-200 rounded-full w-10 h-10' />
          <div className='h-4 w-[120px] bg-gray-200 animate-pulse rounded' />
        </div>

        <div className='hidden md:block h-9 w-[180px] bg-gray-200 animate-pulse rounded' />
      </header>

      <div className='flex flex-col md:flex-row gap-2 md:items-center justify-between p-4 md:h-[48px]'>
        <div className='h-4 w-[172px] bg-gray-200 animate-pulse rounded' />
        <div className='h-4 w-[120px] bg-gray-200 animate-pulse rounded' />

        <div className='md:hidden mt-2 md:mt-0 h-9 w-full md:w-[180px] bg-gray-200 animate-pulse rounded' />
      </div>
    </div>
  );
}

export default SubscriptionCardSkeleton;
